import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";

const PATH = "permissions";

@Injectable({
  providedIn: "root",
})
export class PermissionsHandlerService {
  constructor(private APIService: ApiService) {}

  getPermissions(masterAccountID: number) {
    return this.APIService.get(`${PATH}/${masterAccountID}`);
  }
}
